import { Link } from "react-router-dom";
import OfficialAwardBadge from "./OfficialAwardBadge";

const LOGO = "https://customer-assets.emergentagent.com/job_184a0a73-7ed5-43f8-9a23-0cd69b83d3bb/artifacts/rcargp5m_no%20bkg.png";

const COLUMNS = [
  {
    title: "Explore",
    links: [
      { to: "/rooms", label: "Rooms" },
      { to: "/about", label: "About" },
      { to: "/studio", label: "Studio" },
      { to: "/story", label: "Story" },
      { to: "/faq", label: "FAQ" },
      { to: "/careers", label: "Careers", testid: "footer-careers-link" },
      { to: "/sojourns", label: "Sojourns", testid: "footer-sojourns-link" },
    ],
  },
  {
    title: "Stay",
    links: [
      { to: "/#dates", label: "Check dates & rooms" },
      { to: "/contact", label: "Contact Steve" },
      { to: "/offsites", label: "Team off-sites" },
      { to: "/login", label: "Guest Login" },
    ],
  },
  {
    title: "Coliving Valencia",
    links: [
      { to: "/coliving-valencia", label: "Coliving Valencia" },
      { to: "/quiet-coliving-valencia", label: "Quiet Coliving Valencia" },
      { to: "/luxury-coliving-valencia", label: "Luxury Coliving Valencia" },
      { to: "/coliving-valencia-for-founders", label: "Coliving for Founders" },
      { to: "/coworking-valencia", label: "Coworking Valencia" },
      { to: "/sober-coliving", label: "Sober Coliving" },
      { to: "/best-coliving-spain", label: "Best Coliving in Spain 2026" },
    ],
  },
];

const linkCls = "hover:text-[#2E2A26] transition-colors flex items-center md:inline";

// One footer for every public page. Edit COLUMNS above; every page picks it up.
const PublicFooter = () => (
  <footer className="pb-24 md:pb-12" data-testid="public-footer">
    <div className="bg-[#E8DAC8] text-[#2E2A26] py-8 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <img loading="lazy" decoding="async" src={LOGO} alt="Savi" className="h-7 w-auto" />
              <span className="font-display text-lg tracking-wider">SAVI</span>
            </div>
            <p className="font-serif italic text-[#2E2A26]/70 text-sm mb-1.5">A clear mind, in good company.</p>
            <p className="text-[#2E2A26]/60 text-xs">Sierra Calderona · Valencia</p>
            <p className="text-[#2E2A26]/60 text-xs mt-3">hola@savicoliving.com</p>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title} className={col.title === "Coliving Valencia" ? "col-span-2 md:col-span-2" : ""}>
              <p className="text-sm font-medium mb-3">{col.title}</p>
              <div className={`text-xs text-[#2E2A26]/60 ${col.title === "Coliving Valencia" ? "grid grid-cols-2 md:flex md:flex-col gap-x-4 gap-y-1.5" : "flex flex-col gap-1.5"}`}>
                {col.links.map((l) => l.href ? (
                  <a key={l.href} href={l.href} className={linkCls} data-testid={l.testid}>{l.label}</a>
                ) : (
                  <Link key={l.to} to={l.to} className={linkCls} data-testid={l.testid}>{l.label}</Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="bg-white py-4 px-4">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
        <div className="flex items-center gap-3">
          <OfficialAwardBadge testid="footer-award-badge" width={150} plate={false} />
          <p className="text-[#2E2A26]/40 text-xs">© 2026 SAVI Coliving</p>
        </div>
        <p className="text-[#2E2A26]/40 text-xs text-center">
          Steve also advises owners and investors at{" "}
          <a href="https://thecolivingadvisor.com" target="_blank" rel="noopener noreferrer" className="text-[#C85A38] hover:text-[#A84830] underline underline-offset-2">
            The Coliving Advisor
          </a>
        </p>
        <div className="flex gap-4 text-xs text-[#2E2A26]/40">
          <Link to="/privacy" className={linkCls}>Privacy Policy</Link>
          <Link to="/cookies" className={linkCls}>Cookie Policy</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default PublicFooter;
